import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import AddIcon from '@mui/icons-material/Add';
import ContenedorIncidencias from '../incidencias/ContenedorIncidencias';
import ContenedorPasosDispersion from './ContenedorPasosDispersion';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function BotonArchivoDispersion() {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (event) => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button variant='contained' onClick={(event) => handleClickOpen()} color='success'>
                <AddIcon />  Archivo de dispersión
            </Button>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }} color='info'>
                    <Toolbar >
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Archivo de dispersión
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <ContenedorPasosDispersion />
            </Dialog>
        </>
    );
}